import user from '@/renderer/scripts/utils/user';
import { SMH } from '@/renderer/scripts/smh';

// 批量操作异步任务查询
export function loopAsyncTask(
  request: (params: CoFile.AsyncTaskParams) => any,
  taskIdList: number,
  spaceId?: SMH.SpaceId,
): Promise<any> {
  return new Promise((resolve, reject) => {
    let timer: number | undefined = window.setInterval(async () => {
      user.once('after-logout', () => {
        // 退出登录后清理本地缓存
        window.clearInterval(timer);
        timer = undefined;
        reject(new Error('[SMH Warning]: Logout'));
      });
      user.once('switch-org-started', () => {
        // 切换组织后清理本地缓存
        window.clearInterval(timer);
        timer = undefined;
        reject(new Error('[SMH Warning]: SwitchOrg'));
      });
      try {
        const res = await request({
          taskIdList,
          spaceId,
        });
        /**
         * 400代表任务的空间不足
         * 403代表没有权限
         * 404代表源目录不存在
         * 500服务端问题
         */
        const codes = [200, 204, 207, 400, 403, 404, 500];
        if (codes.includes(res.data[0]?.status)) {
          window.clearInterval(timer);
          timer = undefined;
          resolve(res.data[0]);
        }
      } catch (error) {
        window.clearInterval(timer);
        timer = undefined;
        reject(error);
      }
    }, 1000);
  });
}
